
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/whatsapp-automation-for-travel-companies",
      function () {
        return require("private-next-pages/webinars/whatsapp-automation-for-travel-companies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/whatsapp-automation-for-travel-companies"])
      });
    }
  